import { Flex, Image, ImageProps } from '@chakra-ui/react';

import { Checkbox } from 'uiToolkitV1/Checkbox';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

interface CheckboxCardProps {
  title: React.ReactNode;
  subText?: React.ReactNode;
  checked?: boolean;
  imgSrc?: any;
  imgProps?: ImageProps;
  [key: string]: any;
}

export const CheckboxCard = ({
  title,
  subText,
  checked,
  imgSrc,
  imgProps = {},
  onClick,
  isDisabled = false,
  ...props
}: CheckboxCardProps) => (
  <Flex
    background={checked ? 'neutral.F6FAFE' : 'white'}
    borderRadius="8px"
    borderWidth="1px"
    borderColor="neutral.EBEFF3"
    p={3}
    flexDirection="column"
    width="210px"
    onClickCapture={(e) => {
      !isDisabled && onClick && onClick();
      e.preventDefault();
      e.stopPropagation();
    }}
    cursor={onClick && !isDisabled ? 'pointer' : 'not-allowed'}
    {...props}
  >
    {imgSrc && <Image src={imgSrc} alt="" mb={3} height="64px" borderRadius="8px" {...imgProps} />}
    <Flex p={1} alignItems="flex-start" opacity={isDisabled ? 0.4 : 1}>
      <Flex flexDirection="column" gap="4px">
        <TextBodyMedium bold>{title}</TextBodyMedium>
        <TextLabel color="text.g2">{subText}</TextLabel>
      </Flex>
      <Checkbox m="4px 0 4px auto" isChecked={checked} />
    </Flex>
  </Flex>
);
